import { render, staticRenderFns } from "./attendance.vue?vue&type=template&id=a4513ff6&scoped=true"
import script from "./attendance.vue?vue&type=script&lang=js"
export * from "./attendance.vue?vue&type=script&lang=js"
import style0 from "./attendance.vue?vue&type=style&index=0&id=a4513ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4513ff6",
  null
  
)

export default component.exports